import Service from "../../service/index";

const Share = {
  name: "Share",
  stateFactory: true,
  namespaced: true,
  actions: {
    // eslint-disable-next-line no-unused-vars
    recordShare({ commit }, payload) {
      return Service.Share.recordShare(payload);
    },
  },
};

export default Share;
